import { Icon } from '@buggy/shared'
import { Button, ButtonProps, Modal } from 'antd'
import { FunctionComponent, MouseEvent } from 'react'
import styled, { useTheme } from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'
import { toVoidFunction } from '@/utils/to-void-function'

interface DeleteButtonProps extends Omit<ButtonProps, 'icon' | 'onClick'> {
  confirmModalTitle: string
  confirmModalContent?: string
  beforeDelete?: () => Promise<void> | void
  onDelete: () => Promise<void> | void
  iconSize?: number
  iconColor?: string
}

const DeleteButton: FunctionComponent<DeleteButtonProps> = ({
  beforeDelete,
  onDelete,
  confirmModalTitle,
  confirmModalContent,
  iconSize = 14,
  iconColor,
  disabled,
  ...otherProps
}) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  const handleClick = async (event: MouseEvent<HTMLElement>): Promise<void> => {
    event.stopPropagation()

    await beforeDelete?.()
    Modal.confirm({
      centered: true,
      title: confirmModalTitle,
      content: confirmModalContent,
      cancelText: formatMessage({ id: 'general:btn_text_cancel' }),
      okText: formatMessage({ id: 'general:delete_btn' }),
      onOk: onDelete,
    })
  }

  return (
    <StyledButton
      {...otherProps}
      disabled={disabled}
      icon={
        <Icon
          color={disabled ? theme.colors.text.tooltip : iconColor}
          fontSize={iconSize}
          name='trash-2'
        />
      }
      onClick={toVoidFunction(handleClick)}
    />
  )
}

const StyledButton = styled(Button)``

export default DeleteButton
